import { render, staticRenderFns } from "./task-model-view-left-menu.vue?vue&type=template&id=fd98dce0&scoped=true&"
import script from "./task-model-view-left-menu.vue?vue&type=script&lang=ts&"
export * from "./task-model-view-left-menu.vue?vue&type=script&lang=ts&"
import style0 from "./task-model-view-left-menu.vue?vue&type=style&index=0&id=fd98dce0&lang=less&scoped=true&"
import style1 from "./task-model-view-left-menu.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd98dce0",
  null
  
)

export default component.exports